export default __webpack_public_path__ + "static/media/manager.31a02e31.svg";